import styles from './Accessibilitat.module.sass'
import '../../styles/global.sass'

function Accessibilitat() {
    return(
        <div className={styles.container}>
            <div className='margin_top'></div>
            <div className='container'>
                <h1>Acessibilitat</h1>
                

                <div>
                    <div className={styles.section}>
                        <div className={styles.p2}>
                            Declaració d'accessibilitat
                        </div>
                        <div className={styles.body_regular}>
                            El <strong>Butlletí Oficial del Principat d'Andorra (BOPA)</strong> es compromet a fer accessible el seu lloc web de conformitat amb la <strong>Llei d'accessibilitat, del 6 d'abril de 1995</strong> (modificada per la Llei 27/2017, del 30 de novembre) i amb el principi d'accés universal a la informació pública recollit a la <strong>Llei 33/2021, del 2 de desembre, de transparència, accés a la informació pública i govern obert</strong>.
                        </div>
                        <div className={styles.body_regular}>
                            Com a referència tècnica, aquest lloc pren com a estàndard les <strong>Pautes d'Accessibilitat per al Contingut Web (WCAG) 2.1</strong> del World Wide Web Consortium (W3C), amb l'objectiu d'assolir com a mínim el nivell de conformitat <strong>"Doble A" (AA)</strong>, en línia amb el compromís d'accessibilitat assumit pel Govern d'Andorra per a les seves pàgines web.
                        </div>
                        <div className={styles.body_regular}>
                            Aquesta declaració d'accessibilitat s'aplica al lloc web <a href="https://www.bopa.ad/" target="_blank" rel="noreferrer">https://www.bopa.ad/</a> i als continguts que s'hi publiquen.
                        </div>
                    </div>
                    
                    <div className={styles.section}>
                    <div className={styles.p2}>Contingut no accessible</div>
                    <div className={styles.body_regular}>
                        El contingut que es recull a continuació no és accessible pels motius següents:
                    </div>

                    <div className={styles.section}>
                        <div className={styles.p2}>Manca de conformitat amb la normativa de referència</div>
                        <div className={styles.body_regular}>
                            <ul>
                                <li>Algunes imatges poden no disposar d'una alternativa textual adequada (criteri WCAG 1.1.1).</li>
                                <li>L'estructura d'encapçalaments d'algunes pàgines pot contenir salts en la seva jerarquia (criteri WCAG 1.3.1).</li>
                                <li>El contrast entre el text i el fons pot ser insuficient en determinats elements (criteri WCAG 1.4.3).</li>
                                <li>Alguns documents en format PDF o altres formats ofimàtics poden no complir en la seva totalitat els requisits d'accessibilitat.</li>
                                <li>Algunes llistes no ordenades estan mal formades: dins de l'element &lt;ul&gt; només s'hi admeten com a fills directes els elements &lt;li&gt;, &lt;script&gt; o &lt;template&gt; (criteri WCAG 1.3.1).</li>
                                <li>Algunes pàgines no disposen d'un encapçalament principal de primer nivell (&lt;h1&gt;), de manera que les persones usuàries de productes de suport no poden identificar el tema o l'objectiu principal de la pàgina ni navegar-hi correctament a través de l'estructura d'encapçalaments (criteris WCAG 1.3.1 i 2.4.6).</li>
                            </ul>
                        </div>
                    </div>

                    <div className={styles.section}>
                        <div className={styles.p2}>Càrrega desproporcionada</div>
                        <div className={styles.body_regular}>
                            <ul>
                                <li><em>No aplica</em></li>
                            </ul>
                        </div>
                    </div>

                    <div className={styles.section}>
                        <div className={styles.p2}>Contingut no inclòs dins l'àmbit de la legislació aplicable</div>
                        <div className={styles.body_regular}>
                            <ul>
                                <li>Documents ofimàtics publicats amb anterioritat a la data d'entrada en vigor dels requisits d'accessibilitat, l'actualització dels quals no resulti imprescindible per als serveis actius.</li>
                                <li>Continguts de tercers que no estan finançats ni desenvolupats per l'organisme i que no es troben sota el seu control.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className={styles.section}>
                    <div className={styles.p2}>Preparació d'aquesta declaració d'accessibilitat</div>
                    <div className={styles.body_regular}>
                        La declaració ha estat feta per <strong>Cumulus city.</strong>
                    </div>
                </div>

                <div className={styles.section}>
                    <div className={styles.p2}>Observacions i dades de contacte</div>
                    <div className={styles.body_regular}>
                        Podeu fer comunicacions sobre requisits d'accessibilitat, per exemple:
                        <ul>
                            <li>informar de qualsevol possible incompliment per part d'aquest lloc web;</li>
                            <li>transmetre altres dificultats d'accés al contingut;</li>
                            <li>formular qualsevol altra consulta o suggeriment de millora relatiu a l'accessibilitat del lloc web.</li>
                        </ul>
                        Les comunicacions es poden adreçar a:
                        <ul>
                            <li><strong>Correu electrònic:</strong> <a href="mailto:bopa@bopa.ad">bopa@bopa.ad</a></li>
                            <li><strong>Telèfon:</strong> <a href="tel:+376729410">+376 729410</a></li>
                            <li><strong>Adreça postal:</strong> C/ Prat del Rull, edifici Prat del Rull, 3r pis, AD500 Andorra la Vella</li>
                        </ul>
                        L'organisme responsable atendrà i donarà resposta a les comunicacions rebudes en el termini més breu possible.
                    </div>
                </div>

                <div className={styles.section}>
                    <div className={styles.p2}>Procediment de reclamació</div>
                    <div className={styles.body_regular}>
                        Si, un cop feta una sol·licitud d'informació accessible o una queixa, aquesta ha estat desestimada, no s'està d'acord amb la decisió adoptada, o la resposta no compleix els requisits d'accessibilitat aplicables, la persona interessada es pot adreçar al Butlletí Oficial del Principat d'Andorra, així com exercir les accions administratives i judicials que l'ordenament jurídic andorrà reconegui.
                    </div>
                </div>
                    
                </div>
            </div>
        </div>                        
        








        
    )
}

export default Accessibilitat